import PropTypes from 'prop-types'
import clsx from 'clsx'

import { Alert, Box, Button, Tooltip, Typography } from '@mui/material'

import { makeFormPropTypes } from '../../../../common/formikPropTypes'
import { shippingSend1FromPropTypes } from '../../../../common/propTypes'
import useTranslations from '../../../../i18n/useTranslations'
import { ADDRESS_STATES } from '../../../../common/constants'

import { ReactComponent as PlusCircle } from '../../../../assets/icons/plus-circle.svg'
import { ReactComponent as Notepad } from '../../../../assets/icons/notepad.svg'
import { ReactComponent as MapPin } from '../../../../assets/icons/map-pin.svg'
import { ReactComponent as Sustainable } from '../../../../assets/icons/sustainable.svg'

import useStyles from '../styles'
import LinkButtonTooltip from '../../../../ui/components/LinkButtonTooltip'
import AddressList from './AddressList'
import PickupPoint from './PickupPoint'
import NewAddress from '../../../../context/ShippingSend/Step1Origin/NewAddress'
import { useUserContext } from '../../../../auth/UserProvider'

const AddressSection = props => {
  const {
    isCenterWithAddressesBook,
    values,
    onBlur,
    onChange,
    onClickOpenAgenda,
    isDestination,
    addressList,
    selectAddress,
    centreCode,
    originCentreId,
    fieldErrors,
    autofillAddress,
    countries,
    setErrors,
    zeroResultsGeocode,
    changeDeliveryPointaddress,
    deliveryPoints,
    selectDeliveryPointAddress,
    selectedDeliveryPoint,
    searchedAddress,
    confirmAddress,
    confirmedAddress,
    handlePickUpErrors,
  } = props
  const t = useTranslations()
  const classes = useStyles()
  const { centres } = useUserContext()
  const title = isDestination
    ? t('shipping-send-form:title:destination-address')
    : t('shipping-send-form:title:origin-address')
  const handleClickNewDirection = () =>
    onChange({ target: { name: 'addressState', value: ADDRESS_STATES.NEW } })
  const handleClickExistingDirection = () =>
    onChange({
      target: { name: 'addressState', value: ADDRESS_STATES.EXISTING },
    })
  const handleClickAtPickupPoint = () =>
    onChange({
      target: { name: 'addressState', value: ADDRESS_STATES.AT_PICKUP_POINT },
    })

  return (
    <Box component="section" className={classes.section}>
      <Typography
        variant="h2"
        className={clsx('secondaryTitle', 'decorator', classes.title)}
      >
        {title}
      </Typography>
      <Box mb={3} sx={{ display: 'flex' }}>
        <Button
          size="small"
          startIcon={<Notepad weight="regular" />}
          variant={
            values.addressState === ADDRESS_STATES.EXISTING
              ? 'contained'
              : 'outlined'
          }
          onClick={handleClickExistingDirection}
        >
          {t('shipping-send-form:label:existing-address')}
        </Button>
        <Button
          size="small"
          startIcon={<PlusCircle weight="regular" />}
          variant={
            values.addressState === ADDRESS_STATES.NEW
              ? 'contained'
              : 'outlined'
          }
          onClick={handleClickNewDirection}
        >
          {t('shipping-send-form:label:new-address')}
        </Button>
        <Tooltip
          title={
            <Typography variant="body2">
              {t('message:most-sustainable-option')}
            </Typography>
          }
          placement="top"
          sx={{ order: '2' }}
        >
          <Button
            size="small"
            startIcon={<MapPin weight="regular" />}
            endIcon={<Sustainable weight="regular" />}
            className={
              values.addressState === ADDRESS_STATES.AT_PICKUP_POINT
                ? classes.cttExpressPointButtonContained
                : classes.cttExpressPointButtonOutlined
            }
            onClick={handleClickAtPickupPoint}
          >
            {t('shipping-send-form:label:pick-up-point')}
          </Button>
        </Tooltip>
      </Box>

      {values.addressState === ADDRESS_STATES.EXISTING ? (
        <>
          <AddressList
            addressList={addressList}
            selected={values.address}
            selectAddress={selectAddress}
          />
          {isCenterWithAddressesBook ? (
            <LinkButtonTooltip
              text={t('action:choose-direction-from-agenda')}
              tooltipText={t('tooltip:regular-addresses')}
              onClick={onClickOpenAgenda}
            />
          ) : null}
        </>
      ) : values.addressState === ADDRESS_STATES.NEW ? (
        <>
          <NewAddress
            countries={countries}
            centerCode={centreCode}
            clientCode={originCentreId}
            onChange={onChange}
            values={values}
            onBlur={onBlur}
            errors={fieldErrors}
            zeroResultsGeocode={zeroResultsGeocode}
            autofillAddress={autofillAddress}
            setErrors={setErrors}
            isPhoneRequired
          />
        </>
      ) : values.addressState === ADDRESS_STATES.AT_PICKUP_POINT ? (
        <PickupPoint
          countryRestrictions={['ES', 'PT']}
          changeAddress={changeDeliveryPointaddress}
          deliveryPoints={deliveryPoints}
          selectAddress={selectDeliveryPointAddress}
          selectedAddress={selectedDeliveryPoint}
          searchedAddress={searchedAddress}
          onChange={onChange}
          values={values}
          confirmAddress={confirmAddress}
          confirmedAddress={confirmedAddress}
          handlePickUpErrors={handlePickUpErrors}
        />
      ) : null}

      {selectedDeliveryPoint &&
      ((values.addressState === 'EXISTING' &&
        !values.address.phone.length &&
        !centres.find(({ id }) => values.address.id === id)) ||
        (!isCenterWithAddressesBook && values.addressState === 'EXISTING')) ? (
        <Alert severity="error" className={classes.alertStepTwo}>
          {!isCenterWithAddressesBook && values.addressState === 'EXISTING'
            ? t('shipping-send-form:address:no-address')
            : t('shipping-send-form:address:no-phone-error-center')}
        </Alert>
      ) : null}
    </Box>
  )
}

AddressSection.propTypes = {
  isDestination: PropTypes.bool,

  ...makeFormPropTypes(shippingSend1FromPropTypes),
  isCenterWithAddressesBook: PropTypes.bool,
  onClickOpenAgenda: PropTypes.func,
  addressList: PropTypes.array,
  handlePickUpErrors: PropTypes.func,
}

export default AddressSection
